export default __webpack_public_path__ + "static/media/actions-watched.228d296b.svg";